<template>
  <div>
    <div class="table-container">
      <div class="container-head">
        <label>查询日期</label>
        <el-date-picker
          v-model="time"
          type="daterange"
          align="center"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        ></el-date-picker>
        <el-button
          class="btn"
          :loading="loading"
          type="primary"
          @click="getListData"
          >查询</el-button
        >
      </div>
      <el-table
        :data="tableData"
        stripe
        border=""
        height="500"
        style="width: 100%"
      >
        <el-table-column prop="sStatDay" label="日期"></el-table-column>
        <el-table-column
          prop="iDailyVisitArticlePv"
          label="每日浏览文章次数"
        ></el-table-column>
        <el-table-column
          prop="iDailyVisitArticleUv"
          label="每日浏览文章用户数"
        ></el-table-column>
        <el-table-column
          prop="iDailyShareArticleUv"
          label="每日分享文章用户数"
        ></el-table-column>
        <el-table-column
          prop="iDailyShareArticleNum"
          label="每日分享文章篇数"
        ></el-table-column>
        <el-table-column
          prop="iDailyForwardArticleUv"
          label="每日转发文章用户数"
        ></el-table-column>
        <el-table-column
          prop="iDailyNewShareArticleUv"
          label="每日新增分享文章用户数"
        ></el-table-column>
        <el-table-column
          prop="iTotalShareArticleUv"
          label="累计分享文章用户数"
        ></el-table-column>
        <el-table-column
          prop="iTotalVisitArticleUv"
          label="累计浏览文章用户数"
        ></el-table-column>
        <el-table-column
          prop="iTotalVisitArticlePv"
          label="累计浏览文章次数"
        ></el-table-column>
        <el-table-column
          prop="iDailyForwardArticlePv"
          label="每日转发文章次数"
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import request from "../../api/request";
import { format } from "date-fns";
export default {
  name: "Article",
  data() {
    return {
      tableData: [],
      loading: false,
      time: [new Date(), new Date()],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  created() {
    this.getListData();
  },
  methods: {
    async getListData() {
      if (this.time && this.time.length === 2) {
        this.loading = true;
        const resp = await request.stat.post("cms_global_stat_get", {
          sdate: format(new Date(this.time[0]), "yyyy-MM-dd"),
          edate: format(new Date(this.time[1]), "yyyy-MM-dd")
        });
        this.tableData = resp.data.vStat;
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
h4 {
  text-align: left;
}
.container-head {
  margin-bottom: 20px;
}
.container-head label {
  margin-right: 10px;
}
.btn {
  margin-left: 10px;
}
</style>
